import * as React from 'react';
export const UGSvg = React.forwardRef(function UGSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M1.994 0h12.012C15.106 0 16 .896 16 2.001H0A2 2 0 0 1 1.994 0ZM0 6h16v2H0V6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 2h16v2H0V2Zm0 6h16v2H0V8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 4h16v2H0V4Zm16 6c0 1.112-.893 2-1.994 2H1.994C.894 12 0 11.105 0 10h16Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 4V2h1v2h-1ZM0 2h1v2H0V2Zm15 8V8h1v2h-1ZM0 8h1v2H0V8Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 8,
        cy: 6,
        r: 1,
        fill: '#F7FAFC',
      }),
    ),
  );
});
UGSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var UG = {
  category: 'flag',
  colorable: false,
  name: 'UG',
  svg: UGSvg,
};
